import i18n from 'i18next'

const WEEK_PATTERN = /^([A-Z][a-z]{2})\s+Week\s+(\d+)$/
const DAY_PATTERN = /^([A-Z][a-z]{2})\s+(\d{1,2})$/

/**
 * Translates date formats using i18n locales
 * Supports "Month Week #" and "Month DD" patterns
 */
export const translateWeekFormat = (value: string): string => {
    if (!value || typeof value !== 'string') {
        return value
    }

    const matchers: Array<{
        pattern: RegExp
        formatKey: 'dateFormat.weekFormat' | 'dateFormat.dayFormat'
        map: (m: RegExpExecArray) => Record<string, string | number>
    }> = [
        {
            pattern: WEEK_PATTERN,
            formatKey: 'dateFormat.weekFormat',
            map: (m) => {
                const monthAbbr = m[1]
                const weekNumber = m[2]
                return {
                    weekNumber,
                    month: i18n.t(`dateFormat.monthAbbreviations.${monthAbbr}`),
                }
            },
        },
        {
            pattern: DAY_PATTERN,
            formatKey: 'dateFormat.dayFormat',
            map: (m) => {
                const monthAbbr = m[1]
                const day = m[2]
                return {
                    day,
                    month: i18n.t(`dateFormat.monthAbbreviations.${monthAbbr}`),
                }
            },
        },
    ]

    for (const { pattern, formatKey, map } of matchers) {
        const match = pattern.exec(value)
        if (match) {
            return i18n.t(formatKey, map(match)) as string
        }
    }

    return value
}

export const isWeekFormat = (value: string): boolean => {
    return WEEK_PATTERN.test(value)
}

export const isDayFormat = (value: string): boolean => {
    return DAY_PATTERN.test(value)
}
